import classNames from "classnames";
import "../Navigation.scss";
import React from "react";
import Icon from "../../Icon";

export const SignOutLink = ({ link, loading, collapseSideBar, onClick }) => (
  <li title={link.label} className="navigation__link" key={`nav-link-${link.label}`}>
    <div
      className={classNames("navigation__anchor", {
        "navigation__anchor--collapsed": collapseSideBar,
      })}
      onClick={() => onClick()}
    >
      <Icon weight="light" glyph={link.icon} />
      {loading ? (
        <div
          className={classNames("navigation__anchor--label", {
            "navigation__anchor--label--collapse": collapseSideBar,
          })}
        >
          Signing out..
        </div>
      ) : (
        <div
          className={classNames("navigation__anchor--label", {
            "navigation__anchor--label--collapse": collapseSideBar,
          })}
        >
          {link.label}
        </div>
      )}
    </div>
  </li>
);
